import { render } from "./FirstResetPassword.vue?vue&type=template&id=3079288a&ts=true"
import script from "./FirstResetPassword.vue?vue&type=script&lang=ts"
export * from "./FirstResetPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__